import React from 'react';

export default class GoogleStaticMap extends React.Component {

    constructor(props){
        super(props);
        this.state = { 
            address : props.address,
            fullAddress : props.fullAddress,
            zoom : props.zoom,
            mapHovered : false
        }
    }

    componentWillReceiveProps(nextProps){
		this.setState({
			zoom : nextProps.zoom,			
		})		
	}

	toggleMapHovered(){
        this.setState({mapHovered: ! this.state.mapHovered});        
    }

    render() {
       
        return (
        	<a href={"http://maps.google.com/?q=" + this.state.fullAddress.replace(" ", "+")} target="_blank" onMouseOver={this.toggleMapHovered.bind(this)} onMouseOut={this.toggleMapHovered.bind(this)}>
        		<img style={{width: '320px'}} src={"https://maps.googleapis.com/maps/api/staticmap?center=" + (this.state.mapHovered ? this.state.fullAddress : this.state.address) + "&zoom=" + (this.state.mapHovered ? 10 : 7) + "&size=320x150&scale=2&style=element:geometry.stroke|visibility:off&style=feature:landscape|element:geometry|saturation:-100&style=feature:water|invert_lightness:true&key=AIzaSyBnOf2yhLw5wGlPRACvVpq4iVd6gXUQaMg"} />
        	</a>
          );
    }

}


// WEBPACK FOOTER //
// ./app/components/GoogleStaticMap.js